// +----------------------------------------------------------------------
// | ThisAdmin [ ThisAdmin赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2022 https://www.huchengbin.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed ThisAdmin并不是自由软件，未经许可不能去掉ThisAdmin相关版权
// +----------------------------------------------------------------------
// | Author: ThisAdmin Team   Email: oszzw@qq.com
// +----------------------------------------------------------------------

const routeOptions = [
  {path: 'account_info', name: 'account_info', url: '/user/account_info', meta: {title: '账号资料修改'}},
  {path: 'focus', name: 'user_focus', url: '/user/focus', meta: {title: '我的关注'}},
  {path: 'folder', name: 'user_folder', url: '/user/folder', meta: {title: '我的收藏'}},
  {path: 'home', name: 'user_home', url: '/user/home', meta: {title: '用户中心'}}
]
//循环绑定路由
const children = routeOptions.map(route => {
  return {
    ...route,
    component: () => import(/* webpackChunkName: "[request]" */ '@/views' + route.url + '.vue')
  }
})

export default {
  path: '/user',
  name: 'user',
  meta: {title: '用户中心'},
  component: () => import('@/layout/user.vue'),
  children: children
};